import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { useMemo, useState } from "react"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectStagedFilters, setStagedPeople } from "../slice"
import { FilterMenuShell, FilterOptionRow } from "./FilterMenuShell"

export const PeopleFilterView = ({
    onBack,
    onCancel,
    onApply,
}: {
    onBack: () => void
    onCancel: () => void
    onApply: () => void
}) => {
    const dispatch = useAppDispatch()
    const selected = useAppSelector(selectStagedFilters).people
    const members = useAppSelector(selectWorkspaceMembers)
    const [search, setSearch] = useState("")

    const matches = useMemo(() => {
        const needle = search.trim().toLowerCase()
        if (!needle) return members
        return members.filter((member) => member.fullName.toLowerCase().includes(needle))
    }, [members, search])

    const toggle = (userId: string) =>
        dispatch(
            setStagedPeople(
                selected.includes(userId)
                    ? selected.filter((id) => id !== userId)
                    : [...selected, userId]
            )
        )

    return (
        <FilterMenuShell
            title="People"
            onBack={onBack}
            onCancel={onCancel}
            onApply={onApply}
            onClearAll={selected.length > 0 ? () => dispatch(setStagedPeople([])) : undefined}
        >
            <div className="px-3 pb-2 text-gray-100">
                <InputOutlined
                    value={search}
                    onChange={(e) => setSearch(e.currentTarget.value)}
                    placeholder="Search"
                    leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
                    autoFocus
                />
            </div>

            {matches.length === 0 ? (
                <div className="px-3 py-2 text-gray-300">No people found</div>
            ) : (
                matches.map((member) => (
                    <FilterOptionRow
                        key={member.userId}
                        label={member.fullName}
                        selected={selected.includes(member.userId)}
                        onClick={() => toggle(member.userId)}
                        leftItem={
                            <div className="w-6 h-6 rounded-md overflow-hidden shrink-0">
                                <ProfilePhoto userId={member.userId} fullName={member.fullName} />
                            </div>
                        }
                    />
                ))
            )}
        </FilterMenuShell>
    )
}
